import React from "react";
import { useTranslation } from "react-i18next";
import { Child } from "../../models/ParticipantRegistration";
import ChildForm from "./ChildForm";
import ChildCard from "./ChildCard";
import EAButton from "../shared/Buttons/EAButton";
import EADivider from "../shared/EADivider";
import EAAlert from "../shared/EAAlert";

interface IProps {
  children: Child[];
  editingChildIndex: number | null;
  showChildForm: boolean;
  onAddChild: (child: Child) => void;
  onEditChild: (index: number) => void;
  onDeleteChild: (index: number) => void;
  onCancelChildForm: () => void;
  onShowChildForm: () => void;
  onBack: () => void;
  onRegister: () => void;
  newsletterAgreement: boolean;
  submitError?: string;
}

const ChildrenStep: React.FC<IProps> = ({
  children,
  editingChildIndex,
  showChildForm,
  onAddChild,
  onEditChild,
  onDeleteChild,
  onCancelChildForm,
  onShowChildForm,
  onBack,
  onRegister,
  newsletterAgreement,
  submitError,
}) => {
  const { t } = useTranslation();

  const canRegister = children.length > 0 && !showChildForm;

  return (
    <>
      <h4 className="section-title">{t("zarejestruj_uczestnika")}</h4>

      {/* Display saved children as cards */}
      {children.length > 0 && (
        <div className="children-list">
          {children.map((child, index) => (
            <ChildCard
              key={index}
              child={child}
              onEdit={() => onEditChild(index)}
              onDelete={() => onDeleteChild(index)}
            />
          ))}
        </div>
      )}

      {/* Show child form if adding/editing */}
      {showChildForm && (
        <ChildForm
          onSave={onAddChild}
          onCancel={onCancelChildForm}
          initialData={editingChildIndex !== null ? children[editingChildIndex] : undefined}
          isEditing={editingChildIndex !== null}
          newsletterAgreement={newsletterAgreement}
        />
      )}

      {/* Show "Add another participant" button if not currently showing form */}
      {!showChildForm && (
        <div className="flex-center-center" style={{ marginTop: "24px" }}>
          <EAButton title={t("dodaj_kolejnego_uczestnika")} onClick={onShowChildForm} variant="outlined" fullWidth />
        </div>
      )}

      {/* Show validation message if no children added */}
      {!canRegister && children.length === 0 && (
        <EAAlert message={t("musisz_dodac_przynajmniej_jednego_uczestnika")} type="warning" compact />
      )}

      {submitError && <EAAlert type="error" message={submitError} />}

      <EADivider />

      <div className="buttons flex-between-center">
        <EAButton title={t("wstecz")} onClick={onBack} variant="outlined" />
        <EAButton title={t("zarejestruj_uczestnikow")} onClick={onRegister} disabled={!canRegister} />
      </div>
    </>
  );
};

export default ChildrenStep;

